import { doc, setDoc } from 'firebase/firestore';

import { firestore } from '../firebase';
import EmailTemplate, { EMAIL_TEMPLATE_KEYS } from '../types/EmailTemplate';

// Default templates are imported for seeding only
import { DEFAULT_TEMPLATES } from './emailTemplateDefaults';

export const useEmailTemplateMutators = () => {

  const updateTemplate = async (key: string, updates: Partial<EmailTemplate>): Promise<void> => {
    try {
      const templateDoc = doc(firestore, 'emailTemplates', key);
      await setDoc(templateDoc, updates, { merge: true });
    } catch (error) {
      console.error('Error updating email template:', error);
    }
  };

  const seedDefaults = async (): Promise<void> => {
    try {
      const keys = Object.values(EMAIL_TEMPLATE_KEYS);
      for (const key of keys) {
        const defaultTemplate = DEFAULT_TEMPLATES[key];
        if (defaultTemplate) {
          const templateDoc = doc(firestore, 'emailTemplates', key);
          await setDoc(templateDoc, defaultTemplate);
        }
      }
    } catch (error) {
      console.error('Error seeding default email templates:', error);
    }
  };

  return { updateTemplate, seedDefaults };
};
